import React from 'react';
import { Archive, CalendarMonth, Done, Loop, Schedule, Search, Warning } from '@mui/icons-material';
import { Chip, Stack } from '@mui/material';
import { Guide } from './Details';
import { ReleaseType } from '../__generated__/graphql';

function NoticeOutlineIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-110 -110 1040 1040"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth={70}
      strokeLinejoin="round"
      strokeLinecap="round"
      style={{ display: 'block', marginLeft: 4 }}>
      <path d="M28 26 L28 786 L620 786 L788 618 L788 26 Z" />
      <path d="M620 786 L620 618 L788 618" />
      <path d="M28 152 L788 152" />
    </svg>
  );
}

export function GuideBadges({ guide }: { guide: Guide }) {
  return (
    <Stack direction="row" spacing={0.75} alignItems="center" sx={{ mt: 0.5, mb: 1, flexWrap: 'wrap', rowGap: 0.5 }}>
      <StatusBadge guide={guide} />
      <UnpublishedChangesBadge guide={guide} />
      <RevisionBadge guide={guide} />
      <RevisionPlannedBadge guide={guide} />
      <RevisionAssesmentInProgressBadge guide={guide} />
      <NoticeBadge guide={guide} />
    </Stack>
  );
}

function StatusBadge({ guide }: { guide: Guide }) {
  const releases = guide!.releases ?? [];
  if (releases.length === 0) {
    return <Chip size="small" variant="outlined" icon={<Schedule />} label="Ny" />;
  }
  if (releases[0]?.type === ReleaseType.Archive) {
    return <Chip size="small" variant="outlined" icon={<Archive />} label="Tilbaketrukket" />;
  }
  return <Chip size="small" color="success" icon={<Done />} label="Aktiv" />;
}

function UnpublishedChangesBadge({ guide }: { guide: Guide }) {
  if (!guide!.hasChangesSinceLastPublish) return null;
  const releases = guide!.releases ?? [];
  if (releases.length === 0) return null;
  return <Chip size="small" color="warning" icon={<Warning />} label="Upubliserte endringer" />;
}

function RevisionBadge({ guide }: { guide: Guide }) {
  if (!guide!.ongoingRevision?.id) return null;
  return <Chip size="small" variant="outlined" icon={<Loop />} label="Under revisjon" />;
}

function RevisionPlannedBadge({ guide }: { guide: Guide }) {
  if (!guide!.isRevisionPlanned) return null;
  return <Chip size="small" variant="outlined" icon={<CalendarMonth />} label="Planlagt" />;
}

function RevisionAssesmentInProgressBadge({ guide }: { guide: Guide }) {
  if (!guide!.isRevisionAssesmentInProgress) return null;
  return <Chip size="small" variant="outlined" icon={<Search />} label="Kartlegging pågår" />;
}

function NoticeBadge({ guide }: { guide: Guide }) {
  const count = guide!.notices?.filter((x) => !x!.deletedAt).length ?? 0;
  if (count === 0) return null;
  return (
    <Chip
      size="small"
      icon={<NoticeOutlineIcon />}
      label={`${count} ${count === 1 ? 'merknad' : 'merknader'}`}
      sx={{
        backgroundColor: '#fbc02d',
        color: '#fff',
        '& .MuiChip-icon': { color: '#fff' },
      }}
    />
  );
}
